<template>
    <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
            <v-card-title>
                {{ $t('kelaBatch.search') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-autocomplete
                            v-model="form.Region"
                            :items="kelaRegions"
                            item-text="text"
                            item-value="value"
                            :label="$t('kelaBatch.region')"
                            clearable
                            dense
                            outlined
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model.number="form.Year"
                            :label="$t('kelaBatch.year')"
                            type="number"
                            clearable
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="form.TilitysNro"
                            :label="$t('kelaBatch.tilitysNro')"
                            clearable
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="form.Siirtotunnus"
                            :label="$t('kelaBatch.siirtotunnus')"
                            clearable
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select
                            v-model="form.FeedbackStatus"
                            :items="feedbackStatusOptions"
                            item-text="text"
                            item-value="value"
                            :label="$t('kelaBatch.feedbackStatus')"
                            clearable
                            dense
                            outlined
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select
                            v-model="form.ContainsCombinedTrips"
                            :items="combinedTripsOptions"
                            item-text="text"
                            item-value="value"
                            :label="$t('kelaBatch.containsCombinedTrips')"
                            clearable
                            dense
                            outlined
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="form.SentFrom"
                            :label="$t('kelaBatch.sentFrom')"
                            type="date"
                            clearable
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="form.SentTo"
                            :label="$t('kelaBatch.sentTo')"
                            type="date"
                            clearable
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-btn text @click="clear">{{ $t('kelaBatch.clearFilter') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="close">{{ $t('kelaBatch.closeDialog') }}</v-btn>
                <v-btn color="primary" @click="search">{{ $t('common.search') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { KelaRegions } from "@/models/KelaRegions";

export default {
    name: "KelaBatchSearchDialog",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        currentParams: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            form: {
                Region: null,
                Year: null,
                TilitysNro: null,
                Siirtotunnus: null,
                FeedbackStatus: null,
                ContainsCombinedTrips: null,
                SentFrom: null,
                SentTo: null
            },
            kelaRegions: KelaRegions,
            feedbackStatusOptions: [
                { text: this.$t("kelaBatch.feedbackPending"), value: "Pending" },
                { text: "OK / " + this.$t("kelaBatch.processedCount"), value: "OK" },
                { text: this.$t("common.error"), value: "Error" }
            ],
            combinedTripsOptions: [
                { text: this.$t("kelaBatch.allTrips"), value: null },
                { text: this.$t("kelaBatch.combinedTrips"), value: true },
                { text: this.$t("kelaBatch.singleTrips"), value: false }
            ]
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
    watch: {
        value(val) {
            if (val) {
                this.initForm();
            }
        }
    },
    methods: {
        initForm() {
            const p = this.currentParams || {};
            this.form = {
                Region: p.Region || null,
                Year: p.Year || null,
                TilitysNro: p.TilitysNro || null,
                Siirtotunnus: p.Siirtotunnus || null,
                FeedbackStatus: p.FeedbackStatus !== undefined ? p.FeedbackStatus : null,
                ContainsCombinedTrips: p.ContainsCombinedTrips !== undefined ? p.ContainsCombinedTrips : null,
                SentFrom: p.SentFrom ? p.SentFrom.substring(0, 10) : null,
                SentTo: p.SentTo ? p.SentTo.substring(0, 10) : null
            };
        },
        search() {
            const params = {};
            if (this.form.Region) params.Region = this.form.Region;
            if (this.form.Year) params.Year = this.form.Year;
            if (this.form.TilitysNro) params.TilitysNro = this.form.TilitysNro;
            if (this.form.Siirtotunnus) params.Siirtotunnus = this.form.Siirtotunnus;
            if (this.form.FeedbackStatus !== null && this.form.FeedbackStatus !== undefined) {
                params.FeedbackStatus = this.form.FeedbackStatus;
            }
            if (this.form.ContainsCombinedTrips !== null && this.form.ContainsCombinedTrips !== undefined) {
                params.ContainsCombinedTrips = this.form.ContainsCombinedTrips;
            }
            if (this.form.SentFrom) params.SentFrom = this.form.SentFrom;
            if (this.form.SentTo) params.SentTo = this.form.SentTo;
            this.$emit("search", params);
            this.close();
        },
        clear() {
            this.form = {
                Region: null,
                Year: null,
                TilitysNro: null,
                Siirtotunnus: null,
                FeedbackStatus: null,
                ContainsCombinedTrips: null,
                SentFrom: null,
                SentTo: null
            };
        },
        close() {
            this.dialog = false;
        }
    }
};
</script>
